import { handleServiceCall } from "@services/helpers"
import axios from "@core/plugins/axios.plugin"
import { TaskPayload } from "@types"

export type CreateTaskResponse = { status: "sent"; task_id: string }

export class TaskService {
    /**
     * Récupère les workflows Enedis d'une organisation
     * @param task - Payload de la tâche
     * @returns Identifiant de la tâche créée et son statut
     */
    async createTask(task: TaskPayload): Promise<CreateTaskResponse> {
        return handleServiceCall<CreateTaskResponse>(async () => {
            const { data } = await axios.post(
                `/api/metier/franz/send_task`,
                task
            )
            return data
        })
    }
}
